
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { getDateRange } from "@/utils/dateRangeUtils";

export const useAnalyticsStats = (selectedDateRange: string) => {
  const dateRange = getDateRange(selectedDateRange);

  return useQuery({
    queryKey: ['analytics-stats', selectedDateRange],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('search_analytics')
        .select('*')
        .gte('created_at', dateRange.start)
        .lte('created_at', dateRange.end);
      
      if (error) throw error;
      
      const uniqueSessions = new Set(data.map(item => item.user_session)).size;
      const totalInteractions = data.length;
      const searches = data.filter(item => item.interaction_type === 'search').length;
      const clicks = data.filter(item => item.interaction_type === 'click').length;
      
      return {
        uniqueSessions,
        totalInteractions,
        searches,
        clicks,
        clickThroughRate: searches > 0 ? (clicks / searches * 100).toFixed(1) : '0'
      };
    },
    refetchInterval: selectedDateRange === 'today' ? 30000 : undefined
  });
};
